<template>
  <svg width="4" height="11" viewBox="0 0 4 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.862 11H3.878V0.794H0.504V2.6H1.862V11Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'One',
};
</script>
